<template>
    <div class="content">
        <div class="book-details">
            <!--
            <base-button @click="toggleShareModal" variant="book-details__share">
                <icon-share />
            </base-button>
            -->

            <div class="book-details__overview">
                <div class="book-details__cover">
                    <img :src="pageData.image" :alt="pageData.title">
                </div>

                <div class="shell">
                    <div class="book-details__image">
                        <img :src="pageData.image" :alt="pageData.title">
                    </div>

                    <div class="book-details__overview-entry">
                        <p>{{pageData.title}}</p>

                        <p class="book-details__meta">
                            {{pageData.author}} | {{pageData.pages}} pag
                        </p>

                        <div class="book-details__rating">
                            <rating-stars :rating="pageData.rating"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="book-details__content">
                <tabs initialTab="tab1" class="tabs-details">
                    <template #tabsNav="{ goToTab }">
                        <div class="shell">
                            <slider
                                class="tabs-nav-slider"
                                :slides="tabsNavItems"
                                :autoHeight="true"
                                perView="auto"
                                :loop="false"
                                slideToClicked
                            >
                                <template #default="{slide}">
                                     <button
                                        type="button"
                                        @click="() => handleTabActivation(goToTab, slide.tabId)"
                                        :class="{'is-active': currentTabId === slide.tabId}"
                                    >
                                        <span>{{slide.label}}</span>
                                    </button>
                                </template>
                            </slider>
                        </div>
                    </template>

                    <tab id="tab1">
                        <div class="tab__content">
                            <div class="shell">
                                <div class="book-details__body">
                                    <div class="book-details__entry" v-html="pageData.description" />

                                    <base-button v-if="! pageData.hasUser" @click="toggleFeedbackModal" variant="feedback">
                                        <icon-smile />

                                        <span>L’ho letto</span>
                                    </base-button>

                                    <base-button v-if="pageData.hasUser" variant="primary" :to="`/book/${routeId}/comment/update`">
                                        <icon-undo />
                                        <span>Modifica recensione</span>
                                    </base-button>

                                    <br>

                                    <base-button v-if="! pageData.isPreferred" @click="addPreferred" variant="feedback">
                                        <icon-bookmark />

                                        <span>Aggiungi ai preferiti</span>
                                    </base-button>

                                    <base-button v-if="pageData.isPreferred" @click="removePreferred" variant="feedback">
                                        <icon-bookmark />

                                        <span>Rimuovi dai preferiti</span>
                                    </base-button>

                                    <br>
                                    
                                    <base-button @click="toggleShareModal" variant="feedback">
                                        <icon-share />
                                        <span>Condividi</span>
                                    </base-button>

                                </div>
                            </div>
                        </div>
                    </tab>

                    <tab id="tab2">
                        <div class="tab__content">
                            <div class="shell">
                                <div class="book-details__body">
                                    <review-list :reviews="pageData.reviews"/>

                                    <base-button v-if="pageData.readings > 5" class="book-details__review-btn" :to="`/book/${routeId}/reviews`">
                                        Leggi tutte le recensioni
                                    </base-button>

                                    <base-button v-if="! pageData.hasUser" @click="toggleFeedbackModal" variant="feedback">
                                        <icon-smile />

                                        <span>L’ho letto</span>
                                    </base-button>

                                </div>
                            </div>
                        </div>
                    </tab>

                    <tab id="tab3">
                        <div class="tab__content">
                            <div class="shell">
                                <div class="book-details__body">
                                    <book-location
                                        name="Biblioteca della tua scuola"
                                        :text="'Disponibilità: ' + pageData.disponibilita_biblioteca"
                                        color="#7C37FA"
                                    />

                                    <!--
                                    <book-location-description
                                        title="Questo libro è disponibile anche:"
                                        name="Biblioteca Costanzo"
                                        location="Liceo Giulio Cesare"
                                        :image="require('@/assets/images/temp/library.png')"
                                        :address="`
                                            <p>Responsabile Laura Correale</p>
                                            <p><a href='tel:+6121124445'>Tel. 06121124445</a></p>
                                            <p><a href='mailto:biblioteca@liceogiuliocesare.it'>biblioteca@liceogiuliocesare.it</a></p>
                                            <p>Codici biblioteca: SBN: RMBWG - RM1907</p>
                                        `"
                                    />
                                    -->
                                </div>
                            </div>
                        </div>
                    </tab>
                </tabs>

                <teleport to="#modal-target">
                    <modal
                        v-if="showShareModal"
                        class="modal--share"
                        @on-modal-close="toggleShareModal"
                        defaultActive
                    >
                        <template #default>
                            <div class="book-details-share">
                                <div class="book-details-share__image">
                                    <img :src="pageData.image" :alt="pageData.title">
                                </div>

                                <div class="book-details-share__head">
                                    <p>{{pageData.title}} di {{pageData.author}}</p>

                                    <p class="alt-text">Condividi questo libro</p>
                                </div>

                                <div class="book-details-share__group">

                                    <slider
                                        class="slider-popular"
                                        :slides="this.$store.getters.profileMates"
                                        :autoHeight="true"
                                        :loop="false"
                                        perView="auto"
                                    >
                                        <template #default="{slide}">
                                            <user-avatar
                                                :name="slide.name"
                                                :avatar="slide.avatar"
                                                @click="shareBook(slide.id)"
                                            />
                                        </template>
                                    </slider>

                                </div>
                            </div>
                        </template>
                    </modal>
                </teleport>

                <teleport to="#modal-target">
                    <modal
                        v-if="showFeedbackModal"
                        class="modal--feedback"
                        @on-modal-close="toggleFeedbackModal"
                        defaultActive
                    >
                        <template #default="{ closeModal }">
                            <base-button variant="review review-primary" :to="`/book/${routeId}/comment`">
                                <icon-chat />

                                <span>Scrivi una recensione</span>
                            </base-button>

                            <base-button variant="review" @click="closeModal">
                                <icon-undo />

                                <span>Torna indetro, non l’ho letto!</span>
                            </base-button>
                        </template>
                    </modal>
                </teleport>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, computed, inject, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from "vuex";

import RatingStars from '@/components/rating-stars/rating-stars';
import Tab from '@/components/tabs/tab';
import Tabs from '@/components/tabs/tabs';
import Modal from '@/components/modal/modal';
import BaseButton from '@/components/base-button/base-button';
import IconSmile from '@/components/icons/icon-smile/icon-smile';
import IconShare from '@/components/icons/icon-share/icon-share';
import IconBookmark from '@/components/icons/icon-bookmark/icon-bookmark';
import UserAvatar from '@/components/user-avatar/user-avatar';
import IconUndo from '@/components/icons/icon-undo/icon-undo';
import IconChat from '@/components/icons/icon-chat/icon-chat';
import ReviewList from '@/blocks/review-list/review-list';
import BookLocation from '@/components/book-location/book-location';
import BookLocationDescription from '@/components/book-location/book-location-description';
import Slider from '@/components/slider/slider';
import BookPreview from '@/components/book-preview/book-preview';

export default {
    name: 'BookDetails',

    components: {
        RatingStars,
        Tab,
        Tabs,
        Modal,
        BaseButton,
        IconSmile,
        IconShare,
        IconBookmark,
        UserAvatar,
        IconUndo,
        IconChat,
        ReviewList,
        BookLocation,
        BookLocationDescription,
        BookPreview,
        Slider
    },

    setup() {
        const route = useRoute();
        const store = useStore();        
        const toast = inject("toast");        

        const pageData = ref({
            title: '',
            author: '',
            pages: null,
            rating: '',
            image: '',
            description: ``,
            disponibilita_biblioteca: 0,
            readings: 0,
            readByUsers: [
                {
                    id: '1',
                    name: 'Sarah Costantini',
                    avatar: require('@/assets/images/temp/avatar-1.png'),
                },
                {
                    id: '2',
                    name: 'Gino Patrizi',
                    avatar: require('@/assets/images/temp/avatar-2.png'),
                },
                {
                    id: '3',
                    name: 'Max Arresi',
                    avatar: require('@/assets/images/temp/avatar-3.png'),
                },
                {
                    id: '4',
                    name: 'Giulis Costantini',
                    avatar: require('@/assets/images/temp/avatar-4.png'),
                },
                {
                    id: '5',
                    name: 'Max Arresi',
                    avatar: require('@/assets/images/temp/avatar-3.png'),
                },
            ],
            readByClasses: [
                {
                    id: '1',
                    name: 'II B',
                },
                {
                    id: '2',
                    name: 'III C',
                },
                {
                    id: '3',
                    name: 'II C',
                },
                {
                    id: '4',
                    name: 'I C',
                },
                {
                    id: '5',
                    name: 'IV B',
                }
            ],
            reviews: [
                {
                    id: '1',
                    name: 'Sarah Costantini',
                    rating: '4',
                    avatar: require('@/assets/images/temp/avatar-1.png'),
                    text: 'Rush hour, London. A packed commuter train is torn apart in a collision. Picking through the carnage, ex-special forces profiler Ziba MacKenzie helps a dying '
                },
                {
                    id: '2',
                    name: 'Gino Patrizi',
                    rating: '4',
                    avatar: require('@/assets/images/temp/avatar-2.png'),
                    text: 'Rush hour, London. A packed commuter train is torn apart in a collision. Picking '
                },
                {
                    id: '3',
                    name: 'Rossella Carloni',
                    rating: '2',
                    avatar: require('@/assets/images/temp/avatar-3.png'),
                    text: 'Rush hour, London. A packed commuter train is torn apart in a collision. Picking '
                },
                {
                    id: '4',
                    name: 'Sarah Costantini',
                    rating: '5',
                    avatar: require('@/assets/images/temp/avatar-4.png'),
                    text: 'Rush hour, London. A packed commuter train is torn apart in a collision. Picking through the carnage, ex-special forces '
                },
                {
                    id: '5',
                    name: 'Sarah Costantini',
                    rating: '4',
                    avatar: require('@/assets/images/temp/avatar-1.png'),
                    text: 'Rush hour, London. A packed commuter train is torn apart in a collision. Picking through the carnage, ex-special forces profiler Ziba MacKenzie helps a dying '
                },
                {
                    id: '6',
                    name: 'Gino Patrizi',
                    rating: '4',
                    avatar: require('@/assets/images/temp/avatar-2.png'),
                    text: 'Rush hour, London. A packed commuter train is torn apart in a collision. Picking '
                },
                {
                    id: '7',
                    name: 'Rossella Carloni',
                    rating: '2',
                    avatar: require('@/assets/images/temp/avatar-3.png'),
                    text: 'Rush hour, London. A packed commuter train is torn apart in a collision. Picking '
                },
                {
                    id: '8',
                    name: 'Sarah Costantini',
                    rating: '5',
                    avatar: require('@/assets/images/temp/avatar-4.png'),
                    text: 'Rush hour, London. A packed commuter train is torn apart in a collision. Picking through the carnage, ex-special forces '
                },
            ]
        });

        const tabsNavItems = ref([
            {
                id: 1,
                label: 'Sinossi',
                tabId: 'tab1',
            },
            {
                id: 2,
                label: `Recensioni`,
                tabId: 'tab2',
            },
            {
                id: 3,
                label: 'Dove lo trovo',
                tabId: 'tab3',
            }
        ]);

        const slideUsers = ref([
                {
                    id: '1',
                    name: 'Utente 1',
                    avatar: require('@/assets/images/temp/avatar-1.png'),
                },
                {
                    id: '2',
                    name: 'Utente 2',
                    avatar: require('@/assets/images/temp/avatar-2.png'),
                },
                {
                    id: '3',
                    name: 'Utente 3',
                    avatar: require('@/assets/images/temp/avatar-3.png'),
                },
                {
                    id: '4',
                    name: 'Utente 4',
                    avatar: require('@/assets/images/temp/avatar-4.png'),
                },
                {
                    id: '5',
                    name: 'Utente 5',
                    avatar: require('@/assets/images/temp/avatar-3.png'),
                },
        ]);


        const currentTabId = ref(tabsNavItems.value[0].tabId)

        const showShareModal = ref(false);
        const showFeedbackModal = ref(false);

        const toggleShareModal = () => {
            showShareModal.value = !showShareModal.value
        }

        const toggleFeedbackModal = () => {
            showFeedbackModal.value = !showFeedbackModal.value
        }

        const handleTabActivation = (goToTab, id) => {
            goToTab(id);
            currentTabId.value = id;
        }

        onMounted(() => {
            store.dispatch('loadBook', route.params.id)
            .then(function(result) {
                
                let authors = result.book.authors.map(function(e) {
                    return e.description;
                }).join(',') 

                pageData.value.title = result.book.title;
                pageData.value.image = cover(result.book);
                pageData.value.description = result.book.description;
                pageData.value.author = authors;
                pageData.value.pages = result.book.pages;
                pageData.value.rating = result.book.rating;
                pageData.value.readByUsers = result.book.readByUsers;
                pageData.value.readByClasses = result.book.readByClasses;
                pageData.value.reviews = result.reviews.data;
                pageData.value.readings = result.book.readings;
                pageData.value.hasUser = result.book.hasUser;
                pageData.value.isPreferred = result.book.isPreferred;
                pageData.value.disponibilita_biblioteca = result.book.disponibilita_biblioteca;
            })
            .catch(function(error) {
                console.log(error)
                toast.error('Si è verificato un errore, riprova più tardi!', {
                    position: 'bottom'
                })
            })
        })     
        
        function cover(book) {
            return book.cdn ? 
                book.cdn : 
                apipath + '/cache/images/book-cover/' + book.id;
        }

        function addPreferred() {
            store.dispatch('bookPreferredAdd', route.params.id)
            .then(function(result) {
                pageData.value.isPreferred = true;
                toast.success('Aggiunto ai preferiti!', {
                    position: 'bottom'
                })
            }) 
            .catch(function(error) {
                console.log(error)
                toast.error('Si è verificato un errore, riprova più tardi!', {
                    position: 'bottom'
                })
            })
        }

        function removePreferred() {
            store.dispatch('bookPreferredRemove', route.params.id)
            .then(function(result) {
                pageData.value.isPreferred = false;
                toast.success('Rimosso dai preferiti!', {
                    position: 'bottom'
                })
            }) 
            .catch(function(error) {
                console.log(error)
                toast.error('Si è verificato un errore, riprova più tardi!', {
                    position: 'bottom'
                })
            })
        }

        function shareBook(userId) {
            const data = {
                user_id: userId,
                book_id: route.params.id
                
            }
            store.dispatch('bookShareAdd', data)
            .then(function(result) {
                toast.success('Libro condiviso!', {
                    position: 'bottom'
                })
            }) 
            .catch(function(error) {
                console.log(error)
                toast.error('Si è verificato un errore, riprova più tardi!', {
                    position: 'bottom'
                })
            })
        }

        return {
            pageData,
            handleTabActivation,
            showShareModal,
            toggleShareModal,
            showFeedbackModal,
            toggleFeedbackModal,
            routeId: computed(() => route.params.id),
            tabsNavItems,
            currentTabId,
            cover,
            addPreferred,
            removePreferred,
            slideUsers,
            shareBook         
        }
    }
}
</script>
